import script from "./FormTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./FormTextarea.vue?vue&type=script&setup=true&lang=js"

import "./FormTextarea.vue?vue&type=style&index=0&id=682cc23a&lang=scss"

const __exports__ = script;

export default __exports__